import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=45f54aac&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=45f54aac&prod&lang=less&scoped=true"
import style1 from "./pay.vue?vue&type=style&index=1&id=45f54aac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f54aac",
  null
  
)

export default component.exports